export const Rich = ({ text }) => (text || "").split(/(\*\*[^*]+?\*\*)/g).map((p, i) => (
  p.length > 4 && p.startsWith("**") && p.endsWith("**") ? <b key={i} className="text-white">{p.slice(2, -2)}</b> : p
));

const boldChar = (ch) => {
  const c = ch.codePointAt(0);
  if (c >= 65 && c <= 90) return String.fromCodePoint(0x1d5d4 + c - 65);
  if (c >= 97 && c <= 122) return String.fromCodePoint(0x1d5ee + c - 97);
  if (c >= 48 && c <= 57) return String.fromCodePoint(0x1d7ec + c - 48);
  return ch;
};

// social networks have no bold: same Unicode bold letters MaSa uses when publishing
export const unicodeBold = (text) => (text || "").replace(/\*\*([\s\S]+?)\*\*/g, (_, t) => [...t].map(boldChar).join("")).replace(/\*\*/g, "");
